import { render, staticRenderFns } from "./MesaNewTrocarMesa.vue?vue&type=template&id=4db9eeea&scoped=true"
import script from "./MesaNewTrocarMesa.vue?vue&type=script&lang=js"
export * from "./MesaNewTrocarMesa.vue?vue&type=script&lang=js"
import style0 from "./MesaNewTrocarMesa.vue?vue&type=style&index=0&id=4db9eeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9eeea",
  null
  
)

export default component.exports